const API_KEY = process.env.REACT_APP_AWS_FRIENDZ_API_KEY;
const REGION = process.env.REACT_APP_AWS_REGION;
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getPlaceSuggestions = async (query) => {
  try {
    console.log("BASE_URL:", BASE_URL);
    //const url = `https://albvg9jakf.execute-api.us-east-1.amazonaws.com/test/autocomplete`;
    const url = `${BASE_URL}/autocomplete`;
    console.log("Final URL:", url);
    const requestBody = {
      QueryText: query,
      MaxResults: 5,
      "Filter": { 
        "IncludeCountries": [ "USA" ]
      },
      AdditionalFeatures: [
       "Core"
     ]
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': API_KEY
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API response was not OK: ${errorText}`);
    }

    const data = await response.json();
    return data.ResultItems.map((item) => item.Address.Label);
    
  } catch (error) {
    console.error('Error fetching place suggestions:', error);
    throw error;
  }
};
